import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";

export const servicesOtherBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.services-other', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const slider = section.querySelector('.services-other__slider');
    const prevBtn = section.querySelector('.services-other__arrows-mob .swiper-button-prev');
    const nextBtn = section.querySelector('.services-other__arrows-mob .swiper-button-next');
    const prevBtnDesktop = section.querySelector('.services-other__top-arrows .swiper-button-prev');
    const nextBtnDesktop = section.querySelector('.services-other__top-arrows .swiper-button-next');

    let swiper = null;

    const createSwiper = () => {
        if (swiper !== null) {
            swiper.destroy(true, true);
            swiper = null;
        }

        if (!swiper) {
            swiper = _libs._swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        },
                    },
                    1025: {
                        slidesPerView: 3,
                        navigation: {
                            nextEl: nextBtnDesktop,
                            prevEl: prevBtnDesktop,
                        },

                    },
                    1280: {
                        slidesPerView: 4,
                        navigation: {
                            nextEl: nextBtnDesktop,
                            prevEl: prevBtnDesktop,
                        },
                    },
                },
            });
        }
    }


    createSwiper();

    const rebuildFunc = () => {
        if(viewportChecker.all()){
            createSwiper();
        }
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}